import React from 'react'
import './SliderCard.css'
const SilderCard = () => {
    return (
   <>
    <div className="header"/>
     <ul className="container">
        <li className='card'>
            <img className='card-img' src="https://images.unsplash.com/photo-1521898284481-a5ec348cb555?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80"  class="car-img" alt=""/>
            <div class="content">
                <h2>客製化網站</h2>
                <p>功能敘述</p>
                <button class="btn">探索更多</button>
            </div>
        </li>
        <li class="card">
            <img src="https://images.unsplash.com/photo-1521185496955-15097b20c5fe?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8cHJvZ3JhbW1pbmd8ZW58MHx8MHx8&w=1000&q=80" class="car-img" alt=""/>
            <div class="content">
                <h2>工程師團隊</h2>
                <p>功能敘述</p>
                <button class="btn">探索更多</button>
            </div>
        </li>
        <li class="card">
            <img src="https://images.unsplash.com/photo-1534670007418-fbb7f6cf32c3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80" class="car-img" alt=""/>
            <div class="content">
                <h2>品牌行銷合作</h2>
                <p>功能敘述</p>
                <button class="btn">探索更多</button>
            </div>
        </li>
        <li class="card">
            <img src="https://images.unsplash.com/photo-1505740420928-5e560c06d30e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80" class="car-img" alt=""/>
            <div class="content">
                <h2>商品攝影</h2>
                <p>功能敘述</p>
                <button class="btn">探索更多</button>
            </div>
        </li>
        <li class="card">
            <img src="https://images.unsplash.com/photo-1603131550953-1ca9c19d8d1d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80" class="car-img" alt=""/>
            <div class="content">
                <h2>商業圈合作</h2>
                <p>功能敘述</p>
                <button class="btn">探索更多</button>
            </div>
        </li>
        <li class="card">
            <img src="https://images.unsplash.com/photo-1570038280051-4f1945a59084?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80" class="car-img" alt=""/><div class="content">
                <h2>顧客需求</h2>
                <p>功能敘述</p>
                <button class="btn">探索更多</button>
            </div>
        </li>
    
    
    </ul>

    
    
    </>
    );
}

export default SilderCard
